import swiper from 'swiper';



/*-------------------------------------------------------------
着付け・ヘア＆メイク モーダルスライド
---------------------------------------------------------------*/
var topArea01 = new swiper('.js-top-shop-slider01', {
  effect: "horizontal",
  speed: 600,
  centeredSlides: true,
  slidesPerView: "auto",
  loop: false,
  navigation: {
    nextEl: '#js-top-shop-slider01 .swiper-button-next',
    prevEl: '#js-top-shop-slider01 .swiper-button-prev',
  },
});


let Items01 = document.querySelectorAll('#top-shop-01 .p-shop-list__item');
Items01.forEach((Items01, index) => {
  Items01.addEventListener('click', (e) => {
    //createSwiper01();
    topArea01.slideTo(index, 0);
  })
})


const createSwiper01 = () =>{
  
  //----------------------
  //花嫁着付専門 彩乃会
  //----------------------
  // let mySwiper01_01 = new swiper ('.js-top-shop-slider01-01', {
  //   slidesPerView: 1,
  //   autoplay: 3000,
  //   loop: true,
  //   loopedSlides: 4,
  //   centeredSlides : true,
  //   disableOnInteraction: true,
  //   navigation: {
  //     nextEl: '.js-top-shop-slider01-01 .c-modal-list__item-slide-next',
  //     prevEl: '.js-top-shop-slider01-01 .c-modal-list__item-slide-prev',
  //   },
  // });
  // let thumbs01_01 = new swiper('.js-top-shop-slider01-01-thumb', {
  //   centeredSlides: true,
  //   spaceBetween: 10,
  //   loop: true,
  //   slidesPerView: "auto",
  //   touchRatio: 0.2,
  //   slideToClickedSlide: true,
  //   breakpoints: {
  //     768: {
  //       spaceBetween: 5,
  //     }
  //   },
  // });
  // mySwiper01_01.controller.control = thumbs01_01;
  // thumbs01_01.controller.control = mySwiper01_01;

  //----------------------
  //市之橋美容室
  //----------------------
  // let mySwiper01_02 = new swiper ('.js-top-shop-slider01-02', {
  //   slidesPerView: 1,
  //   autoplay: 3000,
  //   loop: true,
  //   loopedSlides: 4,
  //   centeredSlides : true,
  //   disableOnInteraction: true,
  //   navigation: {
  //     nextEl: '.js-top-shop-slider01-02 .c-modal-list__item-slide-next',
  //     prevEl: '.js-top-shop-slider01-02 .c-modal-list__item-slide-prev',
  //   },
  // });
  // let thumbs01_02 = new swiper('.js-top-shop-slider01-02-thumb', {
  //   centeredSlides: true,
  //   spaceBetween: 10,
  //   loop: true,
  //   slidesPerView: "auto",
  //   touchRatio: 0.2,
  //   slideToClickedSlide: true,
  //   breakpoints: {
  //     768: {
  //       spaceBetween: 5,
  //     }
  //   },
  // });
  // mySwiper01_02.controller.control = thumbs01_02;
  // thumbs01_02.controller.control = mySwiper01_02;
  
  //----------------------
  //花嫁着付専門（彩乃会）
  //----------------------
  // let mySwiper01_03 = new swiper ('.js-top-shop-slider01-03', {
  //   slidesPerView: 1,
  //   autoplay: 3000,
  //   loop: true,
  //   loopedSlides: 4,
  //   centeredSlides : true,
  //   disableOnInteraction: true,
  //   navigation: {
  //     nextEl: '.js-top-shop-slider01-03 .c-modal-list__item-slide-next',
  //     prevEl: '.js-top-shop-slider01-03 .c-modal-list__item-slide-prev',
  //   },
  // });
  // let thumbs01_03 = new swiper('.js-top-shop-slider01-03-thumb', {
  //   centeredSlides: true,
  //   spaceBetween: 10,
  //   loop: true,
  //   slidesPerView: "auto",
  //   touchRatio: 0.2,
  //   slideToClickedSlide: true,
  //   breakpoints: {
  //     768: {
  //       spaceBetween: 5,
  //     }
  //   },
  // });
  // mySwiper01_03.controller.control = thumbs01_03;
  // thumbs01_03.controller.control = mySwiper01_03;
}








/*---------------------------------------------------------------
撮影スタジオ モーダルスライド
-----------------------------------------------------------------*/
var topArea02 = new swiper('.js-top-shop-slider02', {
  effect: "horizontal",
  speed: 600,
  centeredSlides: true,
  slidesPerView: "auto",
  loop: false,
  navigation: {
    nextEl: '#js-top-shop-slider02 .swiper-button-next',
    prevEl: '#js-top-shop-slider02 .swiper-button-prev',
  },
});


let Items02 = document.querySelectorAll('#top-shop-02 .p-shop-list__item');
Items02.forEach((Items02, index) => {
  Items02.addEventListener('click', (e) => {
    createSwiper02();
    topArea02.slideTo(index, 0);
  })
})


const createSwiper02 = () =>{
  //----------------------
  //西松写真撮影事務所
  //----------------------
  let mySwiper02_01 = new swiper ('.js-top-shop-slider02-01', {
    slidesPerView: 1,
    autoplay: 3000,
    loop: true,
    loopedSlides: 5,
    centeredSlides : true,
    disableOnInteraction: true,
    navigation: {
      nextEl: '.js-top-shop-slider02-01 .c-modal-list__item-slide-next',
      prevEl: '.js-top-shop-slider02-01 .c-modal-list__item-slide-prev',
    },
  });
  let thumbs02_01 = new swiper('.js-top-shop-slider02-01-thumb', {
    centeredSlides: true,
    spaceBetween: 10,
    loop: true,
    slidesPerView: "auto",
    touchRatio: 0.2,
    slideToClickedSlide: true,
    breakpoints: {
      768: {
        spaceBetween: 5,
      }
    },
  });
  mySwiper02_01.controller.control = thumbs02_01;
  thumbs02_01.controller.control = mySwiper02_01;

  //----------------------
  //Studio Lily
  //----------------------
  let mySwiper02_02 = new swiper ('.js-top-shop-slider02-02', {
    slidesPerView: 1,
    autoplay: 3000,
    loop: true,
    loopedSlides: 5,
    centeredSlides : true,
    disableOnInteraction: true,
    navigation: {
      nextEl: '.js-top-shop-slider02-02 .c-modal-list__item-slide-next',
      prevEl: '.js-top-shop-slider02-02 .c-modal-list__item-slide-prev',
    },
  });
  let thumbs02_02 = new swiper('.js-top-shop-slider02-02-thumb', {
    centeredSlides: true,
    spaceBetween: 10,
    loop: true,
    slidesPerView: "auto",
    touchRatio: 0.2,
    slideToClickedSlide: true,
    breakpoints: {
      768: {
        spaceBetween: 5,
      }
    },
  });
  mySwiper02_02.controller.control = thumbs02_02;
  thumbs02_02.controller.control = mySwiper02_02;

  //----------------------
  //イシダスタジオ
  //----------------------
  let mySwiper02_03 = new swiper ('.js-top-shop-slider02-03', {
    slidesPerView: 1,
    autoplay: 3000,
    loop: true,
    loopedSlides: 4,
    centeredSlides : true,
    disableOnInteraction: true,
    navigation: {
      nextEl: '.js-top-shop-slider02-03 .c-modal-list__item-slide-next',
      prevEl: '.js-top-shop-slider02-03 .c-modal-list__item-slide-prev',
    },
  });
  let thumbs02_03 = new swiper('.js-top-shop-slider02-03-thumb', {
    centeredSlides: true,
    spaceBetween: 10,
    loop: true,
    slidesPerView: "auto",
    touchRatio: 0.2,
    slideToClickedSlide: true,
    breakpoints: {
      768: {
        spaceBetween: 5,
      }
    },
  });
  mySwiper02_03.controller.control = thumbs02_03;
  thumbs02_03.controller.control = mySwiper02_03;
}











/*-------------------------------------------------------------
レンタル衣装店 モーダルスライド
----------------------------------------------------------------*/
var topArea03 = new swiper('.js-top-shop-slider03', {
  effect: "horizontal",
  speed: 600,
  centeredSlides: true,
  slidesPerView: "auto",
  loop: false,
  navigation: {
    nextEl: '#js-top-shop-slider03 .swiper-button-next',
    prevEl: '#js-top-shop-slider03 .swiper-button-prev',
  },
});


let Items03 = document.querySelectorAll('#top-shop-03 .p-shop-list__item');
Items03.forEach((Items03, index) => {
  Items03.addEventListener('click', (e) => {
    createSwiper03();
    topArea03.slideTo(index, 0);
  })
})


const createSwiper03 = () =>{
  //----------------------
  //貸衣装高砂屋本店
  //----------------------
  let mySwiper03_01 = new swiper ('.js-top-shop-slider03-01', {
    slidesPerView: 1,
    autoplay: 3000,
    loop: true,
    loopedSlides: 5,
    centeredSlides : true,
    disableOnInteraction: true,
    navigation: {
      nextEl: '.js-top-shop-slider03-01 .c-modal-list__item-slide-next',
      prevEl: '.js-top-shop-slider03-01 .c-modal-list__item-slide-prev',
    },
  });
  let thumbs03_01 = new swiper('.js-top-shop-slider03-01-thumb', {
    centeredSlides: true,
    spaceBetween: 10,
    loop: true,
    slidesPerView: "auto",
    touchRatio: 0.2,
    slideToClickedSlide: true,
    breakpoints: {
      768: {
        spaceBetween: 5,
      }
    },
  });
  mySwiper03_01.controller.control = thumbs03_01;
  thumbs03_01.controller.control = mySwiper03_01;

  //----------------------
  //ウェディングベル
  //----------------------
  let mySwiper03_02 = new swiper ('.js-top-shop-slider03-02', {
    slidesPerView: 1,
    autoplay: 3000,
    loop: true,
    loopedSlides: 5,
    centeredSlides : true,
    disableOnInteraction: true,
    navigation: {
      nextEl: '.js-top-shop-slider03-02 .c-modal-list__item-slide-next',
      prevEl: '.js-top-shop-slider03-02 .c-modal-list__item-slide-prev',
    },
  });
  let thumbs03_02 = new swiper('.js-top-shop-slider03-02-thumb', {
    centeredSlides: true,
    spaceBetween: 10,
    loop: true,
    slidesPerView: "auto",
    touchRatio: 0.2,
    slideToClickedSlide: true,
    breakpoints: {
      768: {
        spaceBetween: 5,
      }
    },
  });
  mySwiper03_02.controller.control = thumbs03_02;
  thumbs03_02.controller.control = mySwiper03_02;
}









/*----------------------------------------------------------
飲食店 モーダルスライド
-----------------------------------------------------------*/
var topArea04 = new swiper('.js-top-shop-slider04', {
  effect: "horizontal",
  speed: 600,
  centeredSlides: true,
  slidesPerView: "auto",
  loop: false,
  navigation: {
    nextEl: '#js-top-shop-slider04 .swiper-button-next',
    prevEl: '#js-top-shop-slider04 .swiper-button-prev',
  },
});

let Items04 = document.querySelectorAll('#top-shop-04 .p-shop-list__item');
Items04.forEach((Items04, index) => {
  Items04.addEventListener('click', (e) => {
    createSwiper04();
    topArea04.slideTo(index, 0);
  })
})

const createSwiper04= () =>{

  //----------------------
  //SORANIWA
  //----------------------
  let mySwiper04_01 = new swiper ('.js-top-shop-slider04-01', {
    slidesPerView: 1,
    autoplay: 3000,
    loop: true,
    loopedSlides: 5,
    centeredSlides : true,
    disableOnInteraction: true,
    navigation: {
      nextEl: '.js-top-shop-slider04-01 .c-modal-list__item-slide-next',
      prevEl: '.js-top-shop-slider04-01 .c-modal-list__item-slide-prev',
    },
  });
  let thumbs04_01 = new swiper('.js-top-shop-slider04-01-thumb', {
    centeredSlides: true,
    spaceBetween: 10,
    loop: true,
    slidesPerView: "auto",
    touchRatio: 0.2,
    slideToClickedSlide: true,
    breakpoints: {
      768: {
        spaceBetween: 5,
      }
    },
  });
  mySwiper04_01.controller.control = thumbs04_01;
  thumbs04_01.controller.control = mySwiper04_01;
  //----------------------
  //サンベルジュ・メゾン
  //----------------------
  let mySwiper04_02 = new swiper ('.js-top-shop-slider04-02', {
    slidesPerView: 1,
    autoplay: 3000,
    loop: true,
    loopedSlides: 4,
    centeredSlides : true,
    disableOnInteraction: true,
    navigation: {
      nextEl: '.js-top-shop-slider04-02 .c-modal-list__item-slide-next',
      prevEl: '.js-top-shop-slider04-02 .c-modal-list__item-slide-prev',
    },
  });
  let thumbs04_02 = new swiper('.js-top-shop-slider04-02-thumb', {
    centeredSlides: true,
    spaceBetween: 10,
    loop: true,
    slidesPerView: "auto",
    touchRatio: 0.2,
    slideToClickedSlide: true,
    breakpoints: {
      768: {
        spaceBetween: 5,
      }
    },
  });
  mySwiper04_02.controller.control = thumbs04_02;
  thumbs04_02.controller.control = mySwiper04_02;
  //----------------------
  //おもでなしDINNING福亭
  //----------------------
  let mySwiper04_03 = new swiper ('.js-top-shop-slider04-03', {
    slidesPerView: 1,
    autoplay: 3000,
    loop: true,
    loopedSlides: 3,
    centeredSlides : true,
    disableOnInteraction: true,
    navigation: {
      nextEl: '.js-top-shop-slider04-03 .c-modal-list__item-slide-next',
      prevEl: '.js-top-shop-slider04-03 .c-modal-list__item-slide-prev',
    },
  });
  let thumbs04_03 = new swiper('.js-top-shop-slider04-03-thumb', {
    centeredSlides: true,
    spaceBetween: 10,
    loop: true,
    slidesPerView: "auto",
    touchRatio: 0.2,
    slideToClickedSlide: true,
    breakpoints: {
      768: {
        spaceBetween: 5,
      }
    },
  });
  mySwiper04_03.controller.control = thumbs04_03;
  thumbs04_03.controller.control = mySwiper04_03;
  //----------------------
  //サンミケーレ
  //----------------------
  let mySwiper04_04 = new swiper ('.js-top-shop-slider04-04', {
    slidesPerView: 1,
    autoplay: 3000,
    loop: true,
    loopedSlides: 5,
    centeredSlides : true,
    disableOnInteraction: true,
    navigation: {
      nextEl: '.js-top-shop-slider04-04 .c-modal-list__item-slide-next',
      prevEl: '.js-top-shop-slider04-04 .c-modal-list__item-slide-prev',
    },
  });
  let thumbs04_04 = new swiper('.js-top-shop-slider04-04-thumb', {
    centeredSlides: true,
    spaceBetween: 10,
    loop: true,
    slidesPerView: "auto",
    touchRatio: 0.2,
    slideToClickedSlide: true,
    breakpoints: {
      768: {
        spaceBetween: 5,
      }
    },
  });
  mySwiper04_04.controller.control = thumbs04_04;
  thumbs04_04.controller.control = mySwiper04_04;
  //----------------------
  //清交倶楽部
  //----------------------
  let mySwiper04_05 = new swiper ('.js-top-shop-slider04-05', {
    slidesPerView: 1,
    autoplay: 3000,
    loop: true,
    loopedSlides: 4,
    centeredSlides : true,
    disableOnInteraction: true,
    navigation: {
      nextEl: '.js-top-shop-slider04-05 .c-modal-list__item-slide-next',
      prevEl: '.js-top-shop-slider04-05 .c-modal-list__item-slide-prev',
    },
  });
  let thumbs04_05 = new swiper('.js-top-shop-slider04-05-thumb', {
    centeredSlides: true,
    spaceBetween: 10,
    loop: true,
    slidesPerView: "auto",
    touchRatio: 0.2,
    slideToClickedSlide: true,
    breakpoints: {
      768: {
        spaceBetween: 5,
      }
    },
  });
  mySwiper04_05.controller.control = thumbs04_05;
  thumbs04_05.controller.control = mySwiper04_05;
  //----------------------
  //竹善
  //----------------------
  let mySwiper04_06 = new swiper ('.js-top-shop-slider04-06', {
    slidesPerView: 1,
    autoplay: 3000,
    loop: true,
    loopedSlides: 5,
    centeredSlides : true,
    disableOnInteraction: true,
    navigation: {
      nextEl: '.js-top-shop-slider04-06 .c-modal-list__item-slide-next',
      prevEl: '.js-top-shop-slider04-06 .c-modal-list__item-slide-prev',
    },
  });
  let thumbs04_06 = new swiper('.js-top-shop-slider04-06-thumb', {
    centeredSlides: true,
    spaceBetween: 10,
    loop: true,
    slidesPerView: "auto",
    touchRatio: 0.2,
    slideToClickedSlide: true,
    breakpoints: {
      768: {
        spaceBetween: 5,
      }
    },
  });
  mySwiper04_06.controller.control = thumbs04_06;
  thumbs04_06.controller.control = mySwiper04_06;
  //----------------------
  //塩田温泉夢乃井
  //----------------------
  let mySwiper04_07 = new swiper ('.js-top-shop-slider04-07', {
    slidesPerView: 1,
    autoplay: 3000,
    loop: true,
    loopedSlides: 3,
    centeredSlides : true,
    disableOnInteraction: true,
    navigation: {
      nextEl: '.js-top-shop-slider04-07 .c-modal-list__item-slide-next',
      prevEl: '.js-top-shop-slider04-07 .c-modal-list__item-slide-prev',
    },
  });
  let thumbs04_07 = new swiper('.js-top-shop-slider04-07-thumb', {
    centeredSlides: true,
    spaceBetween: 10,
    loop: true,
    slidesPerView: "auto",
    touchRatio: 0.2,
    slideToClickedSlide: true,
    breakpoints: {
      768: {
        spaceBetween: 5,
      }
    },
  });
  mySwiper04_07.controller.control = thumbs04_07;
  thumbs04_07.controller.control = mySwiper04_07;
}







/*-------------------------------------------------------------
着付け・ヘア＆メイク モーダルスライド
---------------------------------------------------------------*/
var topArea05 = new swiper('.js-top-shop-slider05', {
  effect: "horizontal",
  speed: 600,
  centeredSlides: true,
  slidesPerView: "auto",
  loop: false,
  navigation: {
    nextEl: '#js-top-shop-slider05 .swiper-button-next',
    prevEl: '#js-top-shop-slider05 .swiper-button-prev',
  },
});


let Items05 = document.querySelectorAll('#top-shop-05 .p-shop-list__item');
Items05.forEach((Items05, index) => {
  Items05.addEventListener('click', (e) => {
    createSwiper05();
    topArea05.slideTo(index, 0);
  })
})


const createSwiper05 = () =>{
  
  //----------------------
  //ホテル日航姫路
  //----------------------
  let mySwiper05_01 = new swiper ('.js-top-shop-slider05-01', {
    slidesPerView: 1,
    autoplay: 3000,
    loop: true,
    loopedSlides: 5,
    centeredSlides : true,
    disableOnInteraction: true,
    navigation: {
      nextEl: '.js-top-shop-slider05-01 .c-modal-list__item-slide-next',
      prevEl: '.js-top-shop-slider05-01 .c-modal-list__item-slide-prev',
    },
  });
  let thumbs05_01 = new swiper('.js-top-shop-slider05-01-thumb', {
    centeredSlides: true,
    spaceBetween: 10,
    loop: true,
    slidesPerView: "auto",
    touchRatio: 0.2,
    slideToClickedSlide: true,
    breakpoints: {
      768: {
        spaceBetween: 5,
      }
    },
  });
  mySwiper05_01.controller.control = thumbs05_01;
  thumbs05_01.controller.control = mySwiper05_01;

  //----------------------
  //塩田温泉 夢乃井
  //----------------------
  let mySwiper05_02 = new swiper ('.js-top-shop-slider05-02', {
    slidesPerView: 1,
    autoplay: 3000,
    loop: true,
    loopedSlides: 5,
    centeredSlides : true,
    disableOnInteraction: true,
    navigation: {
      nextEl: '.js-top-shop-slider05-02 .c-modal-list__item-slide-next',
      prevEl: '.js-top-shop-slider05-02 .c-modal-list__item-slide-prev',
    },
  });
  let thumbs05_02 = new swiper('.js-top-shop-slider05-02-thumb', {
    centeredSlides: true,
    spaceBetween: 10,
    loop: true,
    slidesPerView: "auto",
    touchRatio: 0.2,
    slideToClickedSlide: true,
    breakpoints: {
      768: {
        spaceBetween: 5,
      }
    },
  });
  mySwiper05_02.controller.control = thumbs05_02;
  thumbs05_02.controller.control = mySwiper05_02;
  
  //----------------------
  //ホテルモントレ姫路
  //----------------------
  let mySwiper05_03 = new swiper ('.js-top-shop-slider05-03', {
    slidesPerView: 1,
    autoplay: 3000,
    loop: true,
    loopedSlides: 2,
    centeredSlides : true,
    disableOnInteraction: true,
    navigation: {
      nextEl: '.js-top-shop-slider05-03 .c-modal-list__item-slide-next',
      prevEl: '.js-top-shop-slider05-03 .c-modal-list__item-slide-prev',
    },
  });
  let thumbs05_03 = new swiper('.js-top-shop-slider05-03-thumb', {
    centeredSlides: true,
    spaceBetween: 10,
    loop: true,
    slidesPerView: "auto",
    touchRatio: 0.2,
    slideToClickedSlide: true,
    breakpoints: {
      768: {
        spaceBetween: 5,
      }
    },
  });
  mySwiper05_03.controller.control = thumbs05_03;
  thumbs05_03.controller.control = mySwiper05_03;

  //----------------------
  //ホテルクレール日笠
  //----------------------
  let mySwiper05_04 = new swiper ('.js-top-shop-slider05-04', {
    slidesPerView: 1,
    autoplay: 3000,
    loop: true,
    loopedSlides: 3,
    centeredSlides : true,
    disableOnInteraction: true,
    navigation: {
      nextEl: '.js-top-shop-slider05-04 .c-modal-list__item-slide-next',
      prevEl: '.js-top-shop-slider05-04 .c-modal-list__item-slide-prev',
    },
  });
  let thumbs05_04 = new swiper('.js-top-shop-slider05-04-thumb', {
    centeredSlides: true,
    spaceBetween: 10,
    loop: true,
    slidesPerView: "auto",
    touchRatio: 0.2,
    slideToClickedSlide: true,
    breakpoints: {
      768: {
        spaceBetween: 5,
      }
    },
  });
  mySwiper05_04.controller.control = thumbs05_04;
  thumbs05_04.controller.control = mySwiper05_04;
}



/*-------------------------------------------------------------
応募の流れ 一定ループスライド
---------------------------------------------------------------*/

var flowSwiper = new swiper('.top-flow-loop__inner', {
	loop: true,
	slidesPerView: 1,
	loopAdditionalSlides: 5,
	centeredSlides: true,
	allowTouchMove: false,
	speed: 6000,
	autoplay: {
		delay: 0,
	}
});